<template>
  <div>
    <page-header title="门店估值" :crumbs="['投前评估', '门店估值']" :subtitle="`共 ${pageInfo.total} 家门店`">
      <template #actions>
        <button class="btn" @click="getStoreList">刷新</button>
      </template>
    </page-header>

    <DataTable
      :columns="columns"
      :data="storeList"
      :loading="loading"
      :total="pageInfo.total"
      :page="pageInfo.currentPage"
      :page-size="pageInfo.pageSize"
      row-key="storeEntCode"
      empty-text="没有匹配的门店"
      @update:page="handleCurrentChange"
      @update:page-size="handleSizeChange"
      @refresh="getStoreList"
    >
      <template #filters>
        <div class="filter-bar">
          <div class="filter-inline">
            <label>门店名称</label>
            <el-input v-model="searchForm.storeName" placeholder="请输入门店名称" clearable style="width: 170px" @keyup.enter="handleSearch" />
          </div>
          <div class="filter-inline">
            <label>省份</label>
            <el-input v-model="searchForm.province" placeholder="请输入省份" clearable style="width: 120px" @keyup.enter="handleSearch" />
          </div>
          <div class="filter-inline">
            <label>城市</label>
            <el-input v-model="searchForm.city" placeholder="请输入城市" clearable style="width: 120px" @keyup.enter="handleSearch" />
          </div>
          <button class="btn" @click="resetSearch">重置</button>
          <button class="btn btn-primary" @click="handleSearch">查询</button>
        </div>
      </template>

      <template #cell-storeName="{ row }">
        <a class="dt-link" @click="goToStoreEvaluate(row.storeEntCode)">{{ row.storeName || '—' }}</a>
      </template>

      <template #ops="{ row }">
        <button class="dt-op" @click="goToStoreEvaluate(row.storeEntCode)">查看报告</button>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import PageHeader from '@/components/PageHeader.vue'
import DataTable from '@/components/DataTable.vue'
import assetService from '@/services/assetService'
import store from '@/store'

export default {
  name: 'StoreEveList',
  components: { PageHeader, DataTable },
  setup() {
    const router = useRouter()

    const state = reactive({
      storeList: [],
      loading: false,
      searchForm: { storeName: '', province: '', city: '' },
      pageInfo: { currentPage: 1, pageSize: 20, total: 0 }
    })

    const columns = [
      { prop: 'storeName', label: '门店简称', minWidth: 150 },
      { prop: 'storeEntCode', label: '门店企业编码', minWidth: 150 },
      { prop: 'storePattern', label: '开店模式', width: 110 },
      { prop: 'storeEntName', label: '门店企业名称', minWidth: 190 },
      { prop: 'province', label: '省份', width: 100 },
      { prop: 'city', label: '城市', width: 100 }
    ]

    const getStoreList = async () => {
      try {
        state.loading = true
        const response = await assetService.getStoreList({
          ...state.searchForm,
          pageNum: state.pageInfo.currentPage,
          pageSize: state.pageInfo.pageSize,
          tenantId: String(store.state.tenantId ?? '')
        })
        state.storeList = response?.data?.storeList || []
        state.pageInfo.total = response?.data?.size || 0
      } catch (error) {
        ElMessage.error('获取门店列表失败：' + (error?.message || ''))
      } finally {
        state.loading = false
      }
    }

    const handleSearch = () => {
      state.pageInfo.currentPage = 1
      getStoreList()
    }

    const resetSearch = () => {
      state.searchForm = { storeName: '', province: '', city: '' }
      handleSearch()
    }

    const goToStoreEvaluate = (storeEntCode) => {
      router.push(`/store/evaluate/${encodeURIComponent(storeEntCode)}`)
    }

    const handleSizeChange = (size) => {
      state.pageInfo.pageSize = size
      state.pageInfo.currentPage = 1
      getStoreList()
    }

    const handleCurrentChange = (page) => {
      state.pageInfo.currentPage = page
      getStoreList()
    }

    onMounted(getStoreList)

    return {
      ...toRefs(state), columns,
      getStoreList, handleSearch, resetSearch, goToStoreEvaluate,
      handleSizeChange, handleCurrentChange
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-inline {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-inline label {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.btn {
  padding: 6px 14px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--bg-card);
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
}

.btn:hover {
  border-color: var(--brand-500);
  color: var(--brand-500);
}

.btn-primary {
  background: var(--brand-500);
  border-color: var(--brand-500);
  color: #fff;
}

.btn-primary:hover {
  background: var(--brand-600);
  border-color: var(--brand-600);
  color: #fff;
}

.dt-link {
  color: var(--brand-500);
  cursor: pointer;
  text-decoration: none;
}

.dt-link:hover {
  text-decoration: underline;
}
</style>
